import { render, staticRenderFns } from "./modalHorasItinereBase.vue?vue&type=template&id=b95d04b8&scoped=true&"
import script from "./modalHorasItinereBase.vue?vue&type=script&lang=js&"
export * from "./modalHorasItinereBase.vue?vue&type=script&lang=js&"
import style0 from "./modalHorasItinereBase.vue?vue&type=style&index=0&id=b95d04b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95d04b8",
  null
  
)

export default component.exports